import {
  Activity,
  BarChart3,
  Building2,
  CalendarRange,
  FileText,
  LayoutDashboard,
  NotebookPen,
  Settings2,
  Sparkles,
  SquareCheckBig,
} from 'lucide-react';

export const appNavigation = [
  {
    to: '/dashboard',
    label: 'Dashboard',
    description: 'Executive overview and live operating signals',
    icon: LayoutDashboard,
    keywords: ['overview', 'summary', 'metrics'],
  },
  {
    to: '/companies',
    label: 'Companies',
    description: 'Watchlists, company records, and diligence context',
    icon: Building2,
    keywords: ['watchlists', 'targets', 'portfolio'],
  },
  {
    to: '/calendar',
    label: 'Calendar',
    description: 'Meetings, deadlines, and operational events',
    icon: CalendarRange,
    keywords: ['events', 'agenda', 'deadlines'],
  },
  {
    to: '/documents',
    label: 'Documents',
    description: 'Versioned files and storage-backed records',
    icon: FileText,
    keywords: ['files', 'storage', 'library'],
  },
  {
    to: '/notes',
    label: 'Notes',
    description: 'Markdown knowledge base and working drafts',
    icon: NotebookPen,
    keywords: ['knowledge', 'markdown', 'drafts'],
  },
  {
    to: '/tasks',
    label: 'Tasks',
    description: 'Execution tracking for personal and team work',
    icon: SquareCheckBig,
    keywords: ['todos', 'work', 'deliverables'],
  },
  {
    to: '/insights',
    label: 'AI Workspace',
    description: 'Assistant briefings, saved outputs, and prompts',
    icon: Sparkles,
    keywords: ['assistant', 'copilot', 'briefings', 'ai'],
  },
  {
    to: '/activity',
    label: 'Activity',
    description: 'Unified timeline across the workspace',
    icon: Activity,
    keywords: ['timeline', 'audit', 'history'],
  },
  {
    to: '/settings',
    label: 'Settings',
    description: 'Organization admin, members, and feature flags',
    icon: Settings2,
    keywords: ['admin', 'members', 'flags'],
  },
];

export const appIdentityIcon = BarChart3;
